import { render, staticRenderFns } from "./InstructorBreakdownTable.vue?vue&type=template&id=efb594f2"
import script from "./InstructorBreakdownTable.vue?vue&type=script&lang=js"
export * from "./InstructorBreakdownTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports